import OMOPlayLogo from "../assets/images/logo_omoplay_black.svg";
import {useSearchParams} from "react-router-dom";
import {Alert, Button} from "omoplay";

const ErrorPage = () => {
  const [query] = useSearchParams();
  const message = query.get("message")
  const description = query.get("description")

  return (
    <div className={`h-screen w-full flex justify-center items-center login-background-gradient`}>
      <div className="h-full flex-1 bg-white">
        <div className="w-full h-full flex-col items-center justify-center">
          <div>
            <div className="flex justify-center" style={{marginBottom: "20px"}}>
              <img alt="" src={OMOPlayLogo} width="272px" />
            </div>
            <div className="text-center" style={{marginBottom: "43px"}}>NO.1 온오프라인 브랜드사 고객 마케팅 서비스</div>
            <div className="bg-white shadow-lg rounded-[16px] p-[32px] flex-col gap-[20px] w-[458px] border border-gray-300">
              <div className="text-[24px] font-bold">에러</div>
              <div className="text-[16px]">{message}</div>
              <div>
                <Alert type="warning" title={<div dangerouslySetInnerHTML={{__html: description}}></div>} />
              </div>
              <div>
                <Button
                    variants="primary"
                    size="large"
                    onClick={() => window.location.href = "/login"}
                    value="로그인 페이지로"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-1 flex-center-all">
      </div>
    </div>
  );
};
export default ErrorPage;
